import React from "react"

const Title = ({ children }) => <p className="title">{children}</p>

export default Title
